const baseStyle = {
    container: {
        color: "font.primary",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 4,
        cursor: "pointer",
        userSelect: "none",
    },
    title: {
        color: "font.primary",
        fontWeight: "medium",
    },
    headerInner: {
        display: "flex",
        color: "font.primary",
    },
    iconContainer: {
        mr: 2,
    },
    actionButton: {
        svg: {
            color: "primary.500",
            boxSize: 6,
        },
    },
    body: {
        position: "relative",
        mt: -2,
        fontSize: "md",
    },
};
const variants = {
    primary: {
        container: {
            bg: "greyscale.100",
        },
    },
    secondary: {
        container: {
            bg: "greyscale.300",
        },
    },
};
const Collapsible = { variants, baseStyle };
export default Collapsible;
